module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/campaign_banner_202505_pc_a0467d35390f9b546ddda646b60e0883.webp";